import {BaseEntity} from "./BaseEntity";

export class ResourceRequestFile extends BaseEntity {
	comment: string;
	name: string;
	file: File;
	visibleOverall: boolean;
}
